<ng-container *ngIf="searchbar?.enabled; else packageList">
	<app-text-input
		class="block full-width mb-3"
		[fullWidth]="true"
		[prefix]="'search'"
		[floatLabel]="'auto'"
		[debounceTime]="300"
		[parentForm]="form"
		[controlName]="'search'"
		[label]="searchbar.label !== undefined ? (searchbar.label | getLocale: locale?.['searchbar.label']) : defaultSearchLabel"
		[placeholder]="(searchbar.placeholder | getLocale: locale?.['searchbar.placeholder']) || defaultSearchPlaceholder"
	></app-text-input>

	<ng-container *ngIf="this.getSearchValue() as searchQuery; else packageList">
		<app-creative-unit-package-listing-list
			[listings]="creativeUnitPackageListings"
			[searchQuery]="searchQuery"
			[thumbnailStyle]="thumbnailStyle"
			[layout]="'grid-1'"
			[showSizeDetails]="true"
			(selectedListing)="onSelectedListing($event)"
			(selectedPartialListing)="selectedPartialListing.emit($event)"
		></app-creative-unit-package-listing-list>
	</ng-container>
</ng-container>

<div class="collection-table-container listing-container-paginator" *ngIf="showPaginator">
	<mat-paginator
		[length]="totalResults"
		[pageSize]="pageSize"
		[pageSizeOptions]="paginator?.pageSizeOptions || defaultPageSizeOptions"
		(page)="paginationChange($event.pageIndex + 1, $event.pageSize)"
	></mat-paginator>
</div>

<ng-template #packageList>
	<app-creative-unit-package-listing-list
		[listings]="creativeUnitPackageListings"
		[layout]="layout"
		[thumbnailStyle]="thumbnailStyle"
		(selectedListing)="onSelectedListing($event)"
	></app-creative-unit-package-listing-list>
</ng-template>
